import React from 'react';
export default function MapSizeButtons({ increaseSize, decreaseSize, resetSize, }) {
    function handleIncreaseMapSize(event) {
        event.preventDefault();
        increaseSize();
    }
    function handleDecreaseMapSize(event) {
        event.preventDefault();
        decreaseSize();
    }
    function handleResetMapSize(event) {
        event.preventDefault();
        resetSize();
    }
    return (React.createElement("div", { className: "field has-addons hex-size-controls" },
        React.createElement("p", { className: "control" },
            React.createElement("button", { className: "button", onClick: handleDecreaseMapSize },
                React.createElement("span", { className: "icon" },
                    React.createElement("i", { className: "fas fa-magnifying-glass-minus" })))),
        React.createElement("p", { className: "control" },
            React.createElement("button", { className: "button", onClick: handleIncreaseMapSize },
                React.createElement("span", { className: "icon" },
                    React.createElement("i", { className: "fas fa-magnifying-glass-plus" })))),
        React.createElement("p", { className: "control" },
            React.createElement("button", { className: "button", onClick: handleResetMapSize },
                React.createElement("span", { className: "icon" },
                    React.createElement("i", { className: "fas fa-equals" }))))));
}
